import { inject } from '@angular/core';
import { FormConfig } from '../edit-create-form.interfaces';
import { GvTaTrackerAssignmentApiService } from '@shared/services';
import { TRACKER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const migrateTrackerAssignmentsFormConfig = (): FormConfig => {
    const trackerAssignmentApiService = inject(GvTaTrackerAssignmentApiService);

    return {
        fields: [
            {
                key: 'oldTrackerEmployeePositionId',
                label: 'Tracker cũ (đã nghỉ)',
                required: true,
                width: 'full',
                type: 'select',
                config: { 
                    ...TRACKER_SELECT_CONFIG, 
                    service: trackerAssignmentApiService,
                    placeholder: 'Chọn tracker cũ đã nghỉ việc',
                    queryBuilder: (searchTerm: string, baseQuery: any) => {
                        const query: any = { 
                            ...baseQuery, 
                            deletedAt: null,
                            // Filter for ended trackers only
                            toDate: { $ne: null }
                        };

                        if (searchTerm && searchTerm.trim()) {
                            query.text = searchTerm.trim();
                        }

                        return query;
                    }
                },
                customErrorMessage: 'Vui lòng chọn tracker cũ'
            },
            {
                key: 'newTrackerEmployeePositionId',
                label: 'Tracker mới (đang hoạt động)',
                required: true,
                width: 'full',
                type: 'select',
                config: { 
                    ...TRACKER_SELECT_CONFIG, 
                    service: trackerAssignmentApiService,
                    placeholder: 'Chọn tracker mới đang hoạt động',
                    queryBuilder: (searchTerm: string, baseQuery: any) => {
                        const query: any = { 
                            ...baseQuery, 
                            deletedAt: null,
                            // Filter for active trackers only
                            toDate: null
                        };

                        if (searchTerm && searchTerm.trim()) {
                            query.text = searchTerm.trim();
                        }

                        return query;
                    }
                },
                customErrorMessage: 'Vui lòng chọn tracker mới'
            }
        ]
    };
};

